export default "__VITE_ASSET__5UrUugY$__"